var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from "@max/max";
import { AJAX_ERROR_NAME, API_PATH, useRequest } from "./useRequest";
import { InviteRewardAssignStatus, InviteStatus, AssistStatus } from "@/types/teamRanking";
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { INVITE_INVALID_TARGET_CODE, INVITE_LIMIT_CODE, InviteType } from "@/types/shared";
import { useOrderPopup } from "./useOrderPopup";
import { POPUP_ORDER } from "@/const";
export function useInvitePopup(options) {
    var _a, _b;
    const ctx = useMonitorEngineContext();
    const { inviteType, inviter, rewardId, groupId, teamName } = ((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {};
    // const { inviteType, inviter, rewardId, groupId, teamName } = {
    //   inviter: 5118528959,
    //   inviteType: InviteType.INVITE_CALL,
    //   invite_source: 'share',
    //   groupId: 14031,
    //   teamName: ''
    // };
    const { userId } = ((_b = ctx._runtimeInfo) === null || _b === void 0 ? void 0 : _b.commonParams) || {};
    const [invitePopupVisible, setInvitePopupVisible] = useOrderPopup(false, POPUP_ORDER.INVITE_CALL);
    const [gotInvitePoints, setGotInvitePoints] = useState(false);
    const [inviteTeamValue, setInviteTeamValue] = useState();
    const [assistStatus, setAssistStatus] = useState(AssistStatus.NOT_ASSIST);
    const { request } = useRequest(API_PATH.INVITE);
    function requestInvite() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let taskId = null;
                const params = {
                    activityId: options.activityId,
                    leaderId: inviter,
                    followerId: userId,
                    rewardId
                };
                console.log(params);
                switch (Number(inviteType)) {
                    case InviteType.INVITE_CALL:
                        params.inviteName = teamName;
                    case InviteType.INVITE_MEMBER:
                        taskId = options.inviteCallTaskId;
                        params.groupId = groupId;
                        break;
                    case InviteType.INVITE_UNLOCK_FREE_CARD:
                        taskId = options.inviteUnlockFreeCardTaskId;
                        params.rewardId = rewardId;
                        break;
                    default:
                        ctx._raptorReport.monitorReportLog('邀请助力失败，不支持的邀请类型', null, {
                            level: 'warn',
                            category: 'Error',
                            tags: {
                                inviteType
                            }
                        });
                        break;
                }
                if (!taskId)
                    throw new Error('taskId is null');
                const res = yield request(Object.assign(Object.assign({}, params), { taskId }));
                if (!res)
                    throw new Error('res is null');
                switch (res.uni_status_code) {
                    case INVITE_LIMIT_CODE:
                        setAssistStatus(AssistStatus.FAILED);
                        ctx._uiInteractionAPI.toast.show({
                            content: '助力已经达到限度啦～明天再来吧'
                        });
                        return;
                    case INVITE_INVALID_TARGET_CODE:
                        // setAssistStatus(AssistStatus.FAILED);
                        ctx._uiInteractionAPI.toast.show({
                            content: '助力失败，不能给自己战队助力'
                        });
                        return;
                    default:
                        break;
                }
                if (res.status != InviteStatus.SUCCESS) {
                    // 直接return，不需要任何弹窗，不上报error
                    setAssistStatus(AssistStatus.FAILED);
                    return;
                }
                setAssistStatus(AssistStatus.SUCCESS);
                switch (Number(inviteType)) {
                    case InviteType.INVITE_CALL:
                    case InviteType.INVITE_MEMBER:
                        if (res.rewardAssignStatus === InviteRewardAssignStatus.SUCCESS) {
                            setGotInvitePoints(true);
                        }
                        setInviteTeamValue(res.teamValue || 100);
                        setInvitePopupVisible(true);
                        break;
                    case InviteType.INVITE_UNLOCK_FREE_CARD:
                        ctx._uiInteractionAPI.toast.show({
                            content: '助力成功～'
                        });
                        break;
                    default:
                        break;
                }
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.INVITE
                });
            }
            catch (error) {
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.INVITE
                });
                if (error.name !== AJAX_ERROR_NAME) {
                    ctx._raptorReport.monitorReportLog('邀请助力失败', error, {
                        level: 'warn',
                        category: 'Error',
                        tags: {
                            errorInfo: JSON.stringify(error),
                            params: JSON.stringify({
                                activityId: options.activityId,
                                taskId: options.inviteCallTaskId,
                                leaderId: inviter,
                                followerId: userId
                            }),
                            apiPath: API_PATH.INVITE
                        }
                    });
                }
            }
        });
    }
    function requestInviteBrowse(taskId) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            const requestParams = {
                activityId: options.activityId,
                taskId,
                leaderId: inviter,
                followerId: userId,
                inviteName: teamName || '美团小队',
                groupId
            };
            try {
                if (!taskId)
                    throw new Error('taskId is null');
                const res = yield request(Object.assign(Object.assign({}, requestParams), { taskId }));
                (_b = (_a = ctx._raptorReport).monitorReportBizSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
                    apiPath: API_PATH.INVITE
                });
            }
            catch (error) {
                (_d = (_c = ctx._raptorReport).monitorReportBizFailed) === null || _d === void 0 ? void 0 : _d.call(_c, {
                    apiPath: API_PATH.INVITE
                });
                if (error.name !== AJAX_ERROR_NAME) {
                    ctx._raptorReport.monitorReportLog('邀请浏览助力失败', error, {
                        level: 'warn',
                        category: 'Error',
                        tags: {
                            errorInfo: JSON.stringify(error),
                            params: JSON.stringify({
                                activityId: options.activityId,
                                taskId: options.inviteCallTaskId,
                                leaderId: inviter,
                                followerId: userId
                            }),
                            apiPath: API_PATH.INVITE
                        }
                    });
                }
            }
        });
    }
    return {
        invitePopupVisible,
        setInvitePopupVisible,
        gotInvitePoints,
        requestInvite,
        inviteTeamValue,
        /** 助力状态 */
        assistStatus,
        /** 浏览任务完成 */
        requestInviteBrowse
    };
}
